import { render, staticRenderFns } from "./Certificacionestram.vue?vue&type=template&id=7946f007"
import script from "./Certificacionestram.vue?vue&type=script&lang=js"
export * from "./Certificacionestram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports